import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Category } from "../../../utils/api/category/category.type";
import Fade from "react-reveal/Fade";
import { Col } from "react-bootstrap";
import { SubCategoryCard } from "./CategoryCard";
import { AlertInfo } from "../../common/Alert";
import { useGetProductListQuery } from "../../../utils/api/product/product.api";
import { BestSellerCard } from "../BestSellerCard";


function SubCategoriesModal({
    show,
    handleClose,
    category
}: {
    show: boolean,
    handleClose: () => void,
    category?: Category
}) {
    const { data = { results: [], count: 0 } } = useGetProductListQuery({
        categorie: category?.slug,
    });
    return (
        <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton className="">
                <Offcanvas.Title></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="title-container">
                    <Fade bottom>
                        <h3 className="title-home-page-theme text-center">
                            {category?.nom}
                        </h3>
                    </Fade>
                </div>
                <div className="pt-3">
                    <div className="row">
                        {!!category?.sous_categorie &&
                            category?.sous_categorie?.length > 0 ?
                            (category?.sous_categorie?.map((item, index: number) => (
                                <Col
                                    sm={6}
                                    xs={6}
                                    md={4}
                                    lg={3}
                                    key={index}
                                >
                                    <SubCategoryCard
                                        subCategory={item}
                                        category={category}
                                        key={item?.id}
                                    />
                                </Col>
                            )))
                            :
                            (!!data?.results &&
                                data?.results?.length > 0 ?
                                (data?.results?.map((product, index) => (
                                    <Col
                                        sm={6}
                                        xs={6}
                                        md={4}
                                        lg={3}
                                        key={index}
                                        className="mb-3"
                                    >
                                        <BestSellerCard
                                            item={product}
                                            key={product?.id}
                                        />
                                    </Col>
                                ))
                                ) : (<AlertInfo message="Aucun item" />)
                            )
                        }
                    </div>
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default SubCategoriesModal;
